import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { Helmet } from 'react-helmet';
import { Link } from '@reach/router';

const position = [23.685, 90.3563];

const GoogleMap = ({ projects }) => {
  if (typeof window !== 'undefined') {
    return (
      <div>
        <MapContainer
          style={{ minHeight: '550px', Width: '100%', border: '1px solid green' }}
          center={position}
          zoom={7}
          scrollWheelZoom={true}
        >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
            url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
          />
          {projects.map((project, i) => {
            return (
              <Marker
                key={i}
                position={{
                  lat: project?.position?.lat,
                  lng: project?.position?.lon,
                }}
              >
                <Popup>
                  <MapPopup project={project} />
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      </div>
    );
  }
  return null;
};

export default GoogleMap;

const MapPopup = ({ project }) => (
  <div className='mapPopup'>
    <h5>{project?.title}</h5>
    <p>
      {project?.capacity}{' '}
      <Link className='link' to={`/projects/${project.slug}`}>
        Details{' '}
      </Link>
    </p>
  </div>
);
